// src/pages/ContextsPage.jsx
import React from 'react';
import ContextList from '../components/ContextList/ContextList';

const ContextsPage = () => {
  return (
    <div className="flex-1">
      <ContextList />
    </div>
  );
};

export default ContextsPage;
